/* eslint-disable no-await-in-loop */
import axios from 'axios';
import dayjs from 'dayjs';
import { getToken } from './token';

const ENV_BASE_URL = {
  DAC: process.env.REACT_APP_ENV_BASE_URL_DAC ?? '',
  DEV: process.env.REACT_APP_ENV_BASE_URL_DEV ?? '',
  COLLAUDO: process.env.REACT_APP_ENV_BASE_URL_COLLAUDO ?? '',
  FORMAZIONE: process.env.REACT_APP_ENV_BASE_URL_FORMAZIONE ?? '',
  PROD: process.env.REACT_APP_ENV_BASE_URL_PROD ?? '',

  DEFAULT: `${window.location.origin}`,
};

export const feBaseUrl = window.location.origin;

export const apiHost =
  ENV_BASE_URL[process.env.REACT_APP_DEPLOY_ENV] || ENV_BASE_URL.DEFAULT;

export const baseUrl = '/api/';
export const extendUrl = 'rest_api/';

const checkForLocalhostRules = (url = '') => `${apiHost}${url}`;

const axiosApi = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosApi.interceptors.request.use((req) => {
  const { token } = getToken();
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

axiosApi.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 403 && error.config) {
      console.warn('Errore 403: Accesso vietato. Riprovo la richiesta...');

      try {
        // eslint-disable-next-line no-promise-executor-return
        await new Promise((resolve) => setTimeout(resolve, 3000));
        let i = 0;
        while (i < 5) {
          try {
            const response = await axios.request(error.config, {
              method: 'HEAD',
            });
            if (response?.status === 200) {
              return Promise.resolve(response);
            }
          } catch (err) {
            // eslint-disable-next-line no-plusplus
            i++;
          }
        }

        return await axios.request(error.config);
      } catch (retryError) {
        if (retryError.response && retryError.response.data) {
          return Promise.reject(retryError.response.data);
        }
        return Promise.reject(retryError);
      }
    }
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

export function apiCall(url, method, body = null, options = null) {
  return axiosApi[method.toLowerCase()](
    checkForLocalhostRules(url),
    body,
    options
  );
}

// Public call (no Authorization header)
const axiosApiPublic = axios.create({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosApiPublic.interceptors.response.use(
  (res) => res,
  async (error) => {
    if (error.response && error.response.status === 403 && error.config) {
      console.warn('Errore 403: Accesso vietato. Riprovo la richiesta...');

      try {
        // eslint-disable-next-line no-promise-executor-return
        await new Promise((resolve) => setTimeout(resolve, 3000));
        let i = 0;
        while (i < 5) {
          try {
            const response = await axios.request(error.config, {
              method: 'HEAD',
            });
            if (response?.status === 200) {
              return Promise.resolve(response);
            }
          } catch (err) {
            // eslint-disable-next-line no-plusplus
            i++;
          }
        }

        return await axios.request(error.config);
      } catch (retryError) {
        if (retryError.response && retryError.response.data) {
          return Promise.reject(retryError.response.data);
        }
        return Promise.reject(retryError);
      }
    }
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

export function apiCallPublic(url, method, body = null, options = null) {
  return axiosApiPublic[method.toLowerCase()](
    checkForLocalhostRules(url),
    body,
    options
  );
}

export function exportFileCall({
  url = '',
  method = 'GET',
  filename = `${dayjs(new Date()).format('DD/MM/YYYY_hh:mm')}.pdf`,
}) {
  return new Promise((res) => {
    const { token } = getToken();
    axios({
      url: checkForLocalhostRules(url),
      method,
      responseType: 'blob',
      headers: {
        authorization: `Bearer ${token}`,
        'ngrok-skip-browser-warning': 'true',
      },
    })
      .then((response) => {
        // get filename from response header
        const contentDisposition =
          response.headers['content-disposition']?.split(';');
        const name =
          contentDisposition?.length > 1
            ? contentDisposition[1]?.split('=')
            : null;
        // create pdf url
        const pdfUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.setAttribute(
          'download',
          name?.length > 1 ? name[1]?.replaceAll('"', '') : filename
        );
        document.body.appendChild(link);
        link.click();
        res();
      })
      .catch((err) => {
        res(err);
      });
  });
}
